import styled from "styled-components";
import Example from "../assets/profile.png";

export const Background = styled.div`
  background:
    radial-gradient(circle at 20% 30%, #2a2a2a, transparent 60%),
    radial-gradient(circle at 80% 70%, #1c1c1c, transparent 60%),
    linear-gradient(180deg, #000, #111);
  position: fixed;
  inset: 0;
  z-index: -2;

  .star {
    position: absolute;
    width: 2px;
    height: 2px;
    background: #00ff88;
    border-radius: 50%;
    opacity: 0.6;

    filter: drop-shadow(0 0 4px rgba(0, 255, 136, 0.8));

    animation-name: drift;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    /* animation: drift var(--duration) linear infinite; */
  }

  @keyframes drift {
    from {
      transform: translate(0, 0);
    }
    to {
      transform: translate(var(--dx), var(--dy));
    }
  }
`;

export const HomePage = styled.div`
  box-sizing: border-box;
  padding-bottom: 30px;
  width: 100%;
  max-width: 1400px;
`;
export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  padding-inline: 40px;
  height: 80px;
  max-width: 1400px;
  margin-inline: auto;
  pointer-events: auto;
  z-index: 9999999;

  backdrop-filter: blur(10px) saturate(140%);
  -webkit-backdrop-filter: blur(10px) saturate(140%);
`;
export const NavBar = styled.nav`
  display: flex;
  gap: 10px;
  @media (max-width: 950px) {
    display: none;
  }
  button {
    background-color: inherit;
    color: #000000;
    border: none;
    cursor: pointer;
    font-size: 18px;
    font-weight: 700;
  }
`;
export const HireMe = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: #08000045;
  border: 1px solid var(--color-main-text);
  cursor: pointer;
  width: 130px;
  height: 44px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  z-index: 0;
  color: var(--color-main-text);
  transition: color 0.5s ease-in-out;

  @media (max-width: 950px) {
    display: none;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      90deg,
      var(--color-main-text),
      var(--color-linear-green)
    );
    opacity: 0;
    border-radius: 5px;
    z-index: -1;

    /* 👇 AUTO ANIMATION */
    /* animation: pulseGradient 4s infinite; */
  }

  /* Keep hover working */
  &:hover::before {
    opacity: 1;
    animation: none;
  }

  &:hover {
    color: var(--color-red);
  }
  @keyframes pulseGradient {
    0% {
      opacity: 0;
    }
    10% {
      opacity: 1;
    }
    40% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
`;

export const Logo = styled.h1`
  font-weight: 700;
  color: #000000;
  cursor: pointer;
`;

export const ProfileWrapperAbout = styled.div`
  border-radius: 20px;
  height: 650px;
  padding: 50px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  @media (max-width: 1000px) {
    width: 100%;
    height: 400px;
  }
  @media (max-width: 500px) {
    width: 100%;
  }
`;
export const SocialMediaButtons = styled.a`
  background-color: #272522;
  border-radius: 3px;
  border: 2px solid var(--color-brown-border);
  display: flex;
  cursor: pointer;
  transition: background 0.5s ease-in-out;
  position: relative;
  z-index: 99;
  @media (max-width: 768px) {
    border-color: white;
  }

  &:hover {
    background: var(--color-brown-border);
    transition: background 0.5s ease;
  }

  svg {
    padding: 0 10px 10px 10px;
    stroke: #a89d9d;
    &:hover {
      stroke: var(--color-red);
      transition: 0.5s ease;
    }
    @media (max-width: 768px) {
      stroke: white;
    }
    height: 100%;
    width: 100%;
  }
`;
export const SocialIconsContainer = styled.div`
  display: flex;
  gap: 10px;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  max-width: 1400px;
  width: 100%;
  height: 700px;
  margin: 50px auto 0 auto;
  padding: 0 40px;

  color: #000000;
  /* font-size: clamp(24px, 5vw, 60px); Responsive font sizing */
  /* text-align: center; */
  font-weight: 600;
  z-index: 1;

  @media (max-width: 1000px) {
    margin-top: 60px;
    /* font-size: clamp(20px, 6vw, 40px); */
  }

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const Greeting = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin-bottom: 100px;
  color: var(--color-main-text);
  row-gap: 20px;
  h1 {
    font-weight: 400;
    font-size: 3vw;
    /* @media (max-width: 1400px) {
            font-size: 40px;
        } */
    @media (min-width: 1300px) {
      font-size: 40px;
    }
  }
  p {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;
export const Status = styled.span`
  background-color: lime;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
`;
export const LogoImg = styled.div`
  background-image: url(${Example});
  height: 30%;
  width: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`;
export const CVButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  border-radius: 5px;
  background-color: ${({ $bg }) => $bg || "#08000045"};
  border: 2px solid ${({ $border }) => $border || "var(--color-main-text)"};
  cursor: pointer;
  text-decoration: none;
  position: relative;
  z-index: 99;
  padding: 10px 30px;
  transition: ease-in-out;

  &:hover {
    scale: 1.1;
  }
`;
export const NameCon = styled.div`
  border: 2px solid var(--color-main-text);
  border-radius: 10px;
  /* height: 30px; */
  max-width: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  z-index: 99;
  p {
    font: 500 16px/16px "Neue Machina";
    background: inherit;
    width: 99%;
    height: 90%;
    border-radius: 10px;
    text-align: center;
    color: var(--color-main-text);
    padding: 7px 0;
    box-sizing: border-box;
    white-space: nowrap;
    padding-inline: 20px;
  }
`;
export const PersonalInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin: 30px 0;
  grid-gap: 30px;
  z-index: 99999999;
  width: 350px;

  p {
    font-size: clamp(16px, 3.5vw, 20px);
  }
  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;
export const WindowBlack = styled.div`
  border-radius: 10px;
`;
